import LogService from "../../../../../react/core/services/logService";
import getGoogleAnalyticsId from "./getGoogleAnalyticsId";

let scriptsBodyLoaded = false;

const createScriptGAElement = (googleAnalyticsId) => {
    let element = document.createElement("script");
    element.type = "text/javascript";
    element.id = "analyticsId-hdr";

    // var code = ''
    // + '     (function (w, d, s, l, i) { '
    // + '         w[l] = w[l] || []; '
    // + '         w[l].push( '
    // + '                 {'gtm.start': new Date().getTime(), event: 'gtm.js'}  '
    // + '         ); '
    // + '         var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; '
    // + '         j.async = true; '
    // + '         j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl; '
    // + '         f.parentNode.insertBefore(j, f); '
    // + '     })(window, document, 'script', 'dataLayer', ''
    // + googleAnalyticsId
    // + ''); ';

    var code =
        "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=false;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','" +
        googleAnalyticsId +
        "');";

    element.appendChild(document.createTextNode(code));

    return element;
};

const createNoScriptGAElement = (googleAnalyticsId) => {
    let element = document.createElement("noscript");
    element.id = "analyticsId-body";
    // var tag = ' <noscript> '
    //     + '     <iframe src='//www.googletagmanager.com/ns.html?id='
    //     + googleAnalyticsId
    //     + '' height='0' width='0' style='display:none;visibility:hidden'></iframe> '
    //     + ' </noscript> ';

    var tag =
        '<iframe src="https://www.googletagmanager.com/ns.html?id=' +
        googleAnalyticsId +
        '" height="0" width="0" style="display:none visibility:hidden"></iframe>';

    element.appendChild(document.createTextNode(tag));

    return element;
};

const prependHdrToBody = (elem) => {
    if (!elem) {
        return;
    }

    let isLoadedBody = document.getElementById("analyticsId-hdr");

    if (isLoadedBody !== null) {
        return;
    }

    if (scriptsBodyLoaded) {
        return;
    }

    let body = document.getElementsByTagName("body")[0];
    if (!body) {
        return;
    }

    body.append(elem);
    scriptsBodyLoaded = true;
};

const prependToBody = (elem) => {
    if (!elem) {
        return;
    }

    let isLoadedBody = document.getElementById("analyticsId-body");

    if (isLoadedBody !== null) {
        return;
    }

    if (scriptsBodyLoaded) {
        return;
    }

    let body = document.getElementsByTagName("body")[0];
    if (!body) {
        return;
    }

    body.append(elem);
    scriptsBodyLoaded = true;
};

const bootstrapGoogleAnalytics = () => {
    const method = "bootstrapGoogleAnalytics()";
    const currentHost = window.location.hostname;
    const googleAnalyticsId = getGoogleAnalyticsId({ method, currentHost });

    LogService.getLogger().debug("{0}- Current gaId [{1}]", [method, googleAnalyticsId]);

    prependHdrToBody(createScriptGAElement(googleAnalyticsId));
    prependToBody(createNoScriptGAElement(googleAnalyticsId));
};

bootstrapGoogleAnalytics();

export { createScriptGAElement, createNoScriptGAElement, prependHdrToBody, prependToBody };
